import Cookies from 'js-cookie'
import React, { useEffect, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { action_fect_countries } from '../../store/actions/global'
import Cache from '../../utils/cache'
import { useLogin } from '../hooks/common'
import createValidator from '../pages/shoppingcart/validator'
import FacebookEvents from '../ads/events/facebook'

export default Wrapped => {

    const structAddress = (address, ctr, e, p) => {
        const {
            name,
            streetAddress1,
            streetAddress2,
            unit,
            city,
            zipCode,
            phoneNumber,
            isDefaultAddress,
            country,
            state,
            phoneArea,
            cpf,
            email,
            firstName,
            lastName,
        } = address || { country: { value: ctr }, email: e, phoneNumber: p }


        return {
            name,
            streetAddress1,
            streetAddress2,
            unit,
            city,
            zipCode,
            phoneNumber,
            country: country?.value,
            state: state?.value,
            defaultAddress: isDefaultAddress,
            phoneArea: phoneArea,
            cpf,
            email,
            firstName: firstName || name?.split?.(' ')?.[0],
            lastName: lastName || name?.split?.(' ')?.[1],
        }
    }



    return props => {

        const { address, onSubmit, country } = props
        const global = useSelector(state => state.global)
        const pageCustomer = useSelector(state => state.pageCustomer)
        const isLogin = useLogin()
        const dispatch = useDispatch()
        const [areaCode, setAreaCode] = useState(null);

        const validate = createValidator(useIntl(), !isLogin)

        const email = isLogin ? '' : (Cache.get('customerEmail') || Cookies.get('utm_email') || '')
        const phone = pageCustomer?.customer?.phoneNumber || Cache.get('customerPhone') || ''

        const structedAddress = structAddress(address, country, email, phone)

        useEffect(async () => {
            if (!global.countries || global.countries.length < 1) {
                await dispatch(action_fect_countries())
            }
        }, [])

        const checkCountryIp = country => { }

        const handleAddress = formAddress => {
            if (formAddress?.email) {
                Cache.set('customerEmail', formAddress.email, 365 * 24 * 60 * 60)
            }

            let phoneAreaParams = formAddress?.country === "PR" && !!areaCode ? { phoneArea: areaCode } : { phoneArea: undefined };

            if (!address) {

                try {
                    if (formAddress) {
                        FacebookEvents.addPaymentInfo({
                            shippingDetail: {
                                ...formAddress,
                                state: { value: formAddress.state },
                                country: { value: formAddress.country }
                            }
                        })
                    }
                } catch (error) {

                }



                return onSubmit({
                    ...formAddress,
                    ...phoneAreaParams,
                    name: `${formAddress.firstName} ${formAddress.lastName}`,
                    defaultAddress: true,
                })
            } else {
                return onSubmit({
                    ...formAddress,
                    ...phoneAreaParams,
                    name: `${formAddress.firstName} ${formAddress.lastName}`,
                    id: address?.id,
                })
            }
        }


        return <Wrapped
            {...props}
            areaCode={areaCode}
            setAreaCode={setAreaCode}
            shouldExpand={!!address}
            validate={validate}
            countries={global.countries}
            structedAddress={structedAddress}
            handleAddress={handleAddress} />
    }
}